import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DatabaseConnection } from '../../shared/services/database-connection';
import { Distribution, DistributionDataI, Stock, StockGroupe } from '../../shared/model';

@Injectable({
  providedIn: 'root',
})
export class StockGroupeService {

  private end_url = "stock-groupe"
  constructor(
    private http : HttpClient,
    private  dbConnection : DatabaseConnection
  ){

  }
    listStockByGroupe(){
      return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + this.end_url)
    }
  
    siteStockDetails(groupe_id : string){
      return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + this.end_url +"/"+ groupe_id + "/edit")
    }
  
    getDocuments(groupe_id : string){
      return this.http.get<DistributionDataI>(this.dbConnection.remoteApiConnection.value + this.end_url + "/"+ groupe_id)
    }
  
    create(data : any){
      return this.http.post<StockGroupe>(this.dbConnection.remoteApiConnection.value + this.end_url, {stocks : data})
    }
  
    delete(site : string){
       return this.http.delete<any>(this.dbConnection.remoteApiConnection.value + this.end_url+"/"+site)
    }
}
